export const IDS_PREFIX_FORM_CLASS = 'idsF';
export const IDS_PREFIX_TAG_CLASS = 'idsT';
